import React from 'react';
import DeckRefreshContext from './DeckRefreshContext';

export default Component => props => (
  <DeckRefreshContext.Consumer>
    {values => <Component {...props} {...values} />}
  </DeckRefreshContext.Consumer>
);